import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const emergencyText =
  "Alabama has ZERO passport agencies — the state's 5M+ residents have no in-state emergency option. Closest: Atlanta ~150 mi via I-20 (2.5+ hrs) or New Orleans ~340 mi (5.5+ hrs). Hoover is Birmingham's wealthiest suburb — healthcare executives at UAB Hospital attending WHO conferences and corporate leaders at Regions Financial making international deals cannot afford a 5+ hour round trip to Atlanta's single agency, which also serves Georgia's 11M+ residents. Spring tornado season (March–May) makes I-20 one of the most dangerous corridors in the Southeast — EF-4 tornadoes have crossed I-20 in the Birmingham metro, shutting down the only route to Atlanta's agency. When I-20 closes, Hoover is severed from every passport agency in the region.";

const disclaimerText =
  "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

export default function HooverProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Hoover"
      introText="Hoover and Birmingham metro travelers — UAB healthcare executives, Regions Financial corporate leaders, and Jefferson County families heading overseas — have several options for getting a passport fast. Here's how they compare, and why most Greater Birmingham residents choose a registered U.S. Department of State courier for predictable, professional processing."
      options={options}
      emergencyDescription={emergencyText}
      disclaimerText={disclaimerText}
    />
  );
}